<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <rect
      width="24"
      height="24"
      rx="4"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 7.33333C11 6.59667 11.5967 6 12.3333 6C13.07 6 13.6667 6.59667 13.6667 7.33333C13.6667 8.07 13.07 8.66667 12.3333 8.66667C11.5967 8.66667 11 8.07 11 7.33333ZM11 12C11 11.2633 11.5967 10.6667 12.3333 10.6667C13.07 10.6667 13.6667 11.2633 13.6667 12C13.6667 12.7367 13.07 13.3333 12.3333 13.3333C11.5967 13.3333 11 12.7367 11 12ZM12.3333 15.3333C11.5967 15.3333 11 15.93 11 16.6667C11 17.4033 11.5967 18 12.3333 18C13.07 18 13.6667 17.4033 13.6667 16.6667C13.6667 15.93 13.07 15.3333 12.3333 15.3333Z"
      fill="currentColor"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
